PegasusTemplate.CloseButtonView = Em.View.extend({
  classNames: ['vr-close-button-wrapper'],
  templateName: 'controls/close_button',
  didChangeValue: function(){
    Em.run.scheduleOnce('afterRender', this, 'positionMe');
  }.observes('controller.contextWidth', 'controller.contextAlignment'),
  didInsertElement: function(){
    var self = this;
    $(window).on('resize.close_button', function(){
      Em.run( self, 'positionMe' );
    });
    this._super();
    Em.run.scheduleOnce('afterRender', this, 'positionMe');
  },
  willDestroyElement: function(){
    $(window).off('resize.close_button');
    this._super();
  },
  positionMe: function(){
    var left = $('.center-wrapper').outerWidth() / 2;

    if ( this.get('controller.isAlignCloseLeft') ) {
      left -= 1*(this.get('controller.contextWidth') / 2);
      left -= 5;
      this.$().css({
        top: 116,
        left: left
      });

      return;
    }

    left += 1*(this.get('controller.contextWidth') / 2);
    left -= 60;
    left += 7;
    this.$().css({
      top: 116,
      left: left
    });
  }
});
